import React from "react";

const PageHeading: React.FC = (props) => (
  <h1 className="text-4xl font-bold leading-10 md:text-7xl-vw mb-7">
    {props.children}
  </h1>
);

export default PageHeading;
